export const isChar = (value: string) => {
  return value.length === 1 || 'value is not Char';
};